// Client-side date-window guard for admin attendance ops.
// Spec: docs/admin-attendance-create-edit-history.md §1
// Window: start of (current month - 1) → end of today (server tz Asia/Ho_Chi_Minh).
// Server is authoritative; this is just early UX feedback.

import dayjs, { Dayjs } from 'dayjs';

export function getAttendanceWindow(): { min: Dayjs; max: Dayjs } {
  const now = dayjs();
  return {
    min: now.subtract(1, 'month').startOf('month'),
    max: now.endOf('day'),
  };
}

export function isDateInWindow(date: Dayjs | string): boolean {
  const { min, max } = getAttendanceWindow();
  const d = dayjs(date);
  return d.isAfter(min.subtract(1, 'second')) && d.isBefore(max.add(1, 'second'));
}

// For antd DatePicker `disabledDate` prop.
export function disabledAttendanceDate(current: Dayjs): boolean {
  if (!current) return false;
  const { min, max } = getAttendanceWindow();
  return current.isBefore(min, 'day') || current.isAfter(max, 'day');
}
